var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeteam(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 361,
    height: 225,
    viewBox: "0 0 361 225",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 361,
    height: 225,
    rx: 25,
    fill: "url(#paint0_linear_109_13095)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_109_13095)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.454 120.104H181.747V108.523H176.438V106H190.764V108.523H185.454V120.104ZM194.81 116.421C194.938 116.924 195.249 117.311 195.735 117.581C196.229 117.858 196.833 117.989 197.565 117.989C198.408 117.989 199.103 117.77 199.652 117.333C200.202 116.895 200.513 116.297 200.577 115.546H195.597V113.628H200.54C200.449 112.943 200.138 112.41 199.588 112.016C199.048 111.623 198.371 111.426 197.575 111.426C196.842 111.426 196.247 111.572 195.762 111.863C195.277 112.155 194.966 112.534 194.828 113.023H191.478C191.652 111.849 192.274 110.901 193.364 110.179C194.444 109.457 195.854 109.092 197.593 109.092C199.625 109.092 201.236 109.595 202.426 110.602C203.616 111.608 204.211 112.972 204.211 114.693C204.211 116.414 203.616 117.814 202.426 118.828C201.227 119.841 199.616 120.345 197.565 120.345C195.808 120.345 194.398 119.987 193.327 119.28C192.256 118.572 191.633 117.617 191.469 116.428H194.819L194.81 116.421ZM217.238 109.325V111.564H213.192V120.111H209.621V111.564H205.575V109.325H217.238ZM223.517 120.104H220.011V109.325H223.517V115.954H223.737L229.138 109.325H232.644V120.104H229.138V113.395H228.918L223.517 120.104ZM239.839 120.104H236.48V109.325H241.103L244.645 116.224H244.865L248.426 109.325H252.985V120.104H249.625V112.957H249.387L245.963 119.499H243.474L240.05 112.957H239.83V120.104H239.839Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.516 82C137.898 82 139.024 83.1399 139.024 84.5393V106.782C139.024 108.181 137.898 109.321 136.516 109.321C135.134 109.321 134.008 108.181 134.008 106.782V84.5393C134.008 83.1399 135.134 82 136.516 82Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.524 120.09C119.906 120.09 121.032 121.23 121.032 122.629V125.771C121.032 127.17 119.906 128.31 118.524 128.31C117.142 128.31 116.016 127.17 116.016 125.771V122.629C116.016 121.23 117.142 120.09 118.524 120.09Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.508 105.076C110.891 105.076 112.016 106.216 112.016 107.616V117.143C112.016 118.542 110.891 119.682 109.508 119.682C108.126 119.682 107 118.542 107 117.143V107.616C107 106.216 108.126 105.076 109.508 105.076Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.532 86.7266C128.914 86.7266 130.04 87.8665 130.04 89.2659V95.2714C130.04 96.6708 128.914 97.8107 127.532 97.8107C126.149 97.8107 125.023 96.6708 125.023 95.2714V89.2659C125.023 87.8665 126.149 86.7266 127.532 86.7266Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.829 128.552C153.446 128.552 152.32 127.412 152.32 126.012V110.498C152.32 109.099 153.446 107.959 154.829 107.959C156.211 107.959 157.337 109.099 157.337 110.498V126.012C157.337 127.412 156.211 128.552 154.829 128.552Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.391 105.15C162.009 105.15 160.883 106.29 160.883 107.69V117.217C160.883 118.616 162.009 119.756 163.391 119.756C164.773 119.756 165.899 118.616 165.899 117.217V107.69C165.899 106.29 164.773 105.15 163.391 105.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.93 138.858C144.548 138.858 143.422 137.718 143.422 136.318V130.517C143.422 129.117 144.548 127.978 145.93 127.978C147.312 127.978 148.438 129.117 148.438 130.517V136.318C148.438 137.718 147.312 138.858 145.93 138.858Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.524 96.7725C119.906 96.7725 121.032 97.9124 121.032 99.3118V115.271C121.032 116.67 119.906 117.81 118.524 117.81C117.142 117.81 116.016 116.67 116.016 115.271V99.3118C116.016 97.9124 117.142 96.7725 118.524 96.7725Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.532 101.37C128.914 101.37 130.04 102.51 130.04 103.909V136.059C130.04 137.458 128.914 138.598 127.532 138.598C126.149 138.598 125.023 137.458 125.023 136.059V103.9C125.023 102.5 126.149 101.36 127.532 101.36V101.37Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.516 112.019C137.898 112.019 139.024 113.158 139.024 114.558V140.461C139.024 141.861 137.898 143 136.516 143C135.134 143 134.008 141.861 134.008 140.461V114.558C134.008 113.158 135.134 112.019 136.516 112.019Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.93 124.465C144.548 124.465 143.422 123.325 143.422 121.926V89.5257C143.422 88.1263 144.548 86.9863 145.93 86.9863C147.312 86.9863 148.438 88.1263 148.438 89.5257V121.926C148.438 123.325 147.312 124.465 145.93 124.465Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.829 105.512C153.446 105.512 152.32 104.372 152.32 102.973V99.553C152.32 98.1536 153.446 97.0137 154.829 97.0137C156.211 97.0137 157.337 98.1536 157.337 99.553V102.973C157.337 104.372 156.211 105.512 154.829 105.512Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_109_13095",
    x1: 0,
    y1: 0,
    x2: 265.997,
    y2: 307.248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C8EC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#63AAE7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_109_13095"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 146,
    height: 61,
    fill: "white",
    transform: "translate(107 82)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeteam);
export default __webpack_public_path__ + "static/media/teteam.0071c30db6fc0886a34cec90832a8218.svg";
export { ForwardRef as ReactComponent };